import { mediaQueries } from '@tallink/components-lib/src/constants/media'
import React from 'react'
import { useMedia } from 'react-use'

import MorePropTypes from '../../../utils/MorePropTypes'
import DesktopTooltip from './DesktopTooltip'
import MobileTooltip from './MobileTooltip'

export default function Tooltip(props) {
  const smUp = useMedia(mediaQueries.smUp)
  return smUp ? <DesktopTooltip {...props} /> : <MobileTooltip {...props} />
}

Tooltip.propTypes = MorePropTypes.tooltipProps.isRequired
